import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { toSignal } from '@angular/core/rxjs-interop';
import { CatalogService } from '../../services/catalog.service';
import { ContactService } from '../../services/contact.service';
import { Collection, SiteSettings } from '../../models/catalog.model';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [CommonModule, RouterLink, FormsModule],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterComponent {
  private catalog = inject(CatalogService);
  private contact = inject(ContactService);

  readonly collections = toSignal(this.catalog.collections$, { initialValue: [] as Collection[] });
  readonly settings = toSignal(this.catalog.settings$, { initialValue: {} as SiteSettings });

  readonly year = new Date().getFullYear();
  readonly email = signal('');
  readonly newsletterState = signal<'idle' | 'sending' | 'done' | 'error'>('idle');

  get whatsappLink(): string {
    const number = this.settings()['whatsapp_number'] || '923463675594';
    return `https://wa.me/${number}`;
  }

  subscribe(): void {
    const email = this.email().trim();
    if (!email || this.newsletterState() === 'sending') return;
    this.newsletterState.set('sending');
    this.contact.subscribe(email).subscribe({
      next: () => {
        this.newsletterState.set('done');
        this.email.set('');
      },
      error: () => this.newsletterState.set('error'),
    });
  }
}
